export default __webpack_public_path__ + "static/media/expl-dissect_15_EN.0a0891ef.png";